export default __webpack_public_path__ + "static/media/subscribe.e7a47e75.svg";